import React from "react";
import "../../GlobalCss/SPF/CanadaMasterfileTable.css";
// import "./CanadaMfTable.css";
import { useState, useEffect } from "react";
import {
  Form,
  Input,
  Popconfirm,
  Table,
  Typography,
  Button,
  Modal,
  Spin,
  Image,
  Select,
  DatePicker,
} from "antd";
import {
  SendOutlined,
  EditOutlined,
  CheckOutlined,
  CloseOutlined,
  ReloadOutlined,
  DownOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
// import { getPayrollData, refreshPayrollData, updateMFRow } from "../../Repository/TenNinetyNineRepository";
import { ErrorMessage, SuccessMessage, InfoMessage } from "../../Utils/Utils";
import { BaseUrl, JsonConfig, jwtToken } from "../../Repository/BaseRepository";
import axios from "axios";
import {
  updateCanadaMFRow,
  getCanadaPayrollData,
  downloadCanadaMasterfileXL,
  getCanadaPayrollMasterfileData,
} from "../../Repository/CanadaPayrollRepository";

const CanadaMasterfileTable = ({
  tableLoader,
  griddata,
  setGriddata,
  setTableLoader,
  unmatchedData,
}) => {
  const originalData = griddata;
  const [form] = Form.useForm();
  const [editingKey, setEditingKey] = useState("");
  const [rowData, setRowData] = useState([]);
  const [searchRow, setSearchRow] = useState("");
  const [filteredData, setFilteredData] = useState(griddata);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [syncSpin, setSyncSpin] = useState(false);

  const [csvLoader, setCsvLoader] = useState(false);
  const isEditing = (record) => record.id === editingKey;
  const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
  }) => {
    const inputNode = <Input />;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item
            name={dataIndex}
            style={{
              margin: 0,
            }}
          >
            {inputNode}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };
  const filterProps = () => ({
    filteredValue: [searchRow],
    onFilter: (value, record) => {
      return (
        String(record.Client)
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        String(record.CoCode)
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        String(record.FileNo)
          .toLowerCase()
          .includes(String(value).toLowerCase()) ||
        String(record.EmployeeName).toLowerCase().includes(value.toLowerCase())
      );
    },
  });

  const columns = [
    {
      title: "CO CODE",
      key: "CoCode",
      dataIndex: "CoCode",
      editable: true,
      width: 150,
      ...filterProps(),
    },
    {
      title: "FILE NUMBER",
      key: "FileNo",
      dataIndex: "FileNo",
      editable: true,
      width: 170,
    },
    {
      title: "EMPLOYEE NAME",
      key: "EmployeeName",
      dataIndex: "EmployeeName",
      editable: true,
      width: 220,
      ellipsis: true,
      render: (text, record, index) => (
        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
      ),
    },
    {
      title: "PROVINCE",
      key: "Province",
      dataIndex: "Province",
      editable: true,
      width: 180,
      ellipsis: true,
      render: (text, record, index) => (
        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
      ),
    },
    {
      title: "CLIENT",
      key: "Client",
      dataIndex: "Client",
      width: 200,
      editable: true,
      ellipsis: true,
      render: (text, record, index) => (
        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
      ),
    },
    {
      title: "HIRE DATE",
      key: "HireDate",
      dataIndex: "HireDate",
      editable: true,
      width: 120,
    },
    {
      title: "RATE TYPE",
      key: "RateType",
      dataIndex: "RateType",
      editable: true,
      width: 180,
    },
    {
      title: "PAYRATE",
      key: "Payrate",
      dataIndex: "Payrate",
      editable: true,
      width: 180,
    },
    {
      title: "PAY FREQUENCY",
      key: "PayFrequency",
      dataIndex: "PayFrequency",
      editable: true,
      width: 180,
    },
    {
      title: "FLSA",
      key: "FLSA",
      dataIndex: "FLSA",
      editable: true,
      width: 170,
    },
    {
      title: "TERM DATE",
      key: "TermDate",
      dataIndex: "TermDate",
      editable: true,
      width: 180,
    },
    {
      title: "RT",
      key: "RT",
      dataIndex: "RT",
      editable: true,
      width: 80,
    },
    {
      title: "OT",
      key: "OT",
      dataIndex: "OT",
      editable: true,
      width: 80,
    },
    {
      title: "DT",
      key: "DT",
      dataIndex: "DT",
      editable: true,
      width: 80,
    },
    {
      title: "STATUS",
      key: "Status",
      dataIndex: "Status",
      editable: true,
      width: 190,
      ellipsis: true,
      render: (text, record, index) => (
        <div style={{ whiteSpace: "normal", lineHeight: "1.3" }}>{text}</div>
      ),
    },
    {
      title: "SALARIED",
      key: "Salaried",
      dataIndex: "Salaried",
      editable: true,
      width: 180,
    },
    // {
    //     title: 'COMMENTS',
    //     key: 'Comments',
    //     dataIndex: 'Comments',
    //     editable: true,
    //     width: 180
    // },
    {
      title: "WEEKEND",
      key: "Weekend",
      dataIndex: "Weekend",
      // editable: true,
      width: 180,
    },
    // {
    //     title: 'ACTION',
    //     dataIndex: 'action',
    //     fixed: 'right',
    //     width: 100,
    //     render: (_, record) => {
    //         const editable = isEditing(record);
    //         return editable ? (
    //             <span>
    //                 <Popconfirm title="Sure to save?" onConfirm={() => editTableRowData(record)}
    //                     onCancel={cancel}>
    //                     <Typography.Link
    //                         style={{
    //                             marginRight: 8,
    //                         }}
    //                     >
    //                         <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
    //                     </Typography.Link>
    //                 </Popconfirm>
    //                 <Typography.Link onClick={() => cancel()}>
    //                     <CloseOutlined style={{ color: "red" }} />
    //                 </Typography.Link>

    //             </span>
    //         ) : (
    //             <div>
    //                 <Typography.Link onClick={() => edit(record)} disabled={editingKey !== ''} >
    //                     <Image
    //                         src="./Images/editicon.svg"
    //                         style={{
    //                             border: "none",
    //                             width: "100% ",
    //                             marginRight: 5
    //                         }}
    //                         showPreviewIcon={false}
    //                         preview={false}
    //                     />
    //                 </Typography.Link>
    //             </div>

    //         );
    //     },
    // },
  ];
  const edit = (record) => {
    setRowData(record);
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record.id);
    // console.log(rec)
  };
  const compareObjects = (obj1, obj2) => {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    if (
      keys1.length !== keys2.length ||
      !keys1.every((key) => keys2.includes(key))
    ) {
      return false;
    }
    for (const key of keys1) {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }
    return true;
  };
  const compareLists = (rowData, currentRowData) => {
    if (typeof rowData !== "object" || typeof currentRowData !== "object") {
      return false;
    }
    const result = compareObjects(rowData, currentRowData);
    return result;
  };
  function formatDateToYYYYMMDD(date) {
    if (date !== null) {
      if (date !== "") {
        const [month, day, year] = date.split("/");
        return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
      }
    } else {
      return null;
    }
  }
  const editTableRowData = async (props) => {
    try {
      const currentRowData = await form.getFieldValue();
      const comparision = compareLists(rowData, currentRowData);
      if (comparision === false) {
        const tempWeekend = formatDateToYYYYMMDD(currentRowData.Weekend);
        const tempWeekStart = formatDateToYYYYMMDD(
          currentRowData.WeekStartDate
        );
        const data = {
          id: currentRowData.id,
          client_Type: currentRowData.Client_Type,
          client: currentRowData.Client,
          payroll_Name: currentRowData.Payroll_Name,
          weekend: tempWeekend,
          rt: currentRowData.RT,
          ot: currentRowData.OT,
          dt: currentRowData.DT,
          status: currentRowData.Status,
          other_Hours: currentRowData.Other_Hours,
          WeekStartDate: tempWeekStart,
          userName: currentRowData.UserName,
          invoice_Date: currentRowData.Invoice_Date,
          invoice_Hrs: currentRowData.Invoice_Hrs,
          invoice_Number: currentRowData.Invoice_Number,
        };
        const updateresponse = await updateCanadaMFRow(data);
        if (updateresponse.data.statusCode === 200) {
          const res = await getCanadaPayrollData(newFrom, newTo);
          if (res !== null && res.length > 0) {
            setGriddata(res);
          }
          SuccessMessage(updateresponse.data.message);
        } else if (updateresponse.data.statusCode === 500) {
          InfoMessage(updateresponse.data.message);
        } else {
          ErrorMessage("Cannot able to update, please try again");
        }
        setEditingKey("");
      } else {
        InfoMessage("No changes made. Edit and try again.");
      }
    } catch (err) {
      return err;
    }
  };
  const cancel = () => {
    setEditingKey("");
  };
  const deleteGridRow = (record) => {
    setEditingKey("");
  };
  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };


  return (
    <>
      <div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexDirection: "row",
          }}
        >
          <Input
            placeholder="Search Co Code\ Client \ File Number \ Empoyee Name"
            className="MFten-searchrow"
            style={{ width: "50%", marginLeft: "30px" }}
            onChange={(e) => setSearchRow(e.target.value)}
            allowClear
            suffix={
              <SearchOutlined
                style={{ color: "#7185FF", justifyContent: "space-between" }}
              />
            }
          />

        </div>
        <div
          className={
            griddata.length > 0 ? "ten99-table-class" : "ten99-empty-table"
          }
          style={{ marginTop: 40 }}
        >
          {tableLoader ? (
            <Spin tip="Loading...">
              <Form form={form} component={false}>
                <Table
                  className="ten99-table"
                  rowClassName="editable-row"
                  columns={mergedColumns}
                  dataSource={originalData.map((item) => ({
                    ...item,
                    key: item.id,
                  }))}
                  components={{ body: { cell: EditableCell } }}
                  bordered
                  // rowSelection={rowSelection}
                  scroll={{ x: 1500, y: 400 }}
                  // pagination
                />{" "}
              </Form>{" "}
            </Spin>
          ) : griddata.length > 0 ? (
            <Form form={form} component={false}>
              <Table
                className="ten99-table"
                rowClassName="editable-row"
                columns={mergedColumns}
                dataSource={originalData.map((item) => ({
                  ...item,
                  key: item.id,
                }))}
                components={{ body: { cell: EditableCell } }}
                bordered
                // rowSelection={rowSelection}
                scroll={{ x: 1500, y: 400 }}
              />
            </Form>
          ) : (
            <Form form={form} component={false}>
              <Table
                className="ten99-table"
                rowClassName="editable-row"
                columns={mergedColumns}
                dataSource={originalData.map((item) => ({
                  ...item,
                  key: item.id,
                }))}
                components={{ body: { cell: EditableCell } }}
                bordered
                // rowSelection={rowSelection}
                scroll={{ x: 400, y: 400 }}
              />
            </Form>
          )}
        </div>
      </div>

      {/* <div className="crawl-prepare-row">
            <Button className="crawl-prepare-button">Crawl & Prepare</Button>
        </div> */}
    </>
  );
};
export default CanadaMasterfileTable;
